import React from 'react';
import SliderBannerGalery from '../../../../shared/components/atoms/slider-galery/slider-banner-galery';
import useMobile from '../../../hooks/useMobile';
import Breadcumb from '../../atoms/breadcrumb/breadcrumb';
import './banner.scss';

const Banner = props => {

    const { imagen, imagenMobile, titulo, children, showImagenMobile, showBreadCrumb, bannerSlider, page = 'Home', subBanner } = props;

    const isMobile = useMobile();
    
    return (
        <div className="m-banner_flex-container">            
            <div className="m-banner_flex-item">
                <div className={"m-banner_breadcrumb-container " + ((!isMobile && showBreadCrumb) ? 'show' : '')}>
                    <Breadcumb page={ page }/>
                </div>
                {children}
            </div>
            <div className="m-banner_flex-item">
                {
                    subBanner || ( !bannerSlider || bannerSlider?.length < 2 ) ? (
                        <div className={"m-banner_img-container " + (showImagenMobile ? 'show' : '')}>
                            <img
                                src={(isMobile && imagenMobile) ? imagenMobile : imagen}
                                alt={titulo}
                                title={titulo}
                            />                   
                        </div>
                    ) : (
                        <SliderBannerGalery banner={bannerSlider} /> 
                    )                    
                }    
                                      
                {/*<div className={"m-banner_img-container " + (showImagenMobile ? 'show' : '')}>
                    <img
                        src={(isMobile && imagenMobile) ? imagenMobile : imagen}
                        alt={titulo}
                        title={titulo}
                    />                   
    </div>*/}
            </div>
        </div>
    )
}

export default Banner
